module.exports = __webpack_public_path__ + "static/media/BikeSharing-kickoff.05e3e8f5.pdf";